import { useEffect, useState } from 'react';
import { MOBILE_VIEW_BREAKPOINT } from '../constants/styling';
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}
function useIsMobileView() {
  const {
    width
  } = useWindowSize();
  return width < MOBILE_VIEW_BREAKPOINT;
}
export { useWindowSize, useIsMobileView };